import styled from 'styled-components';

import { StatusColorIndicator } from './StatusCell';

const InlineStatusColorIndicator = styled(StatusColorIndicator)`
  display: inline-block;
  vertical-align: middle;
`;

export default InlineStatusColorIndicator;
